import { createAllActions } from '@api/createRequestStore';
import * as types from './types';

const { init, fetching } = createAllActions(types.SCOPE);

const fetchWidgetMessages = () => ({
  type: types.FETCH_DATA,
});

const setLoadingState = (tabKey, loadingState) => ({
  type: types.SET_LOADING_STATE,
  tabKey,
  loadingState,
});

const setResponse = ({ tabKey, response, errorMsg }) => ({
  type: types.SET_RESPONSE,
  tabKey,
  response,
  errorMsg,
});

const setActiveTab = (tabKey) => ({
  type: types.SET_ACTIVE_TAB,
  tabKey,
})

export {
  init,
  fetching,
  fetchWidgetMessages,
  setLoadingState,
  setResponse,
  setActiveTab,
};
